export const designerControl = {
  resetView: () => {
    document
      .querySelector(".sqd-control-bar > .sqd-control-bar-button[title='Reset view']")
      ?.click();
  },
  redo: () => {
    document.querySelector(".sqd-control-bar > .sqd-control-bar-button[title='Redo']")?.click();
  },
  undo: () => {
    document.querySelector(".sqd-control-bar > .sqd-control-bar-button[title='Undo']")?.click();
  },
};
